import React, { useEffect, useState } from 'react';
import './App.css';
import './styles/boardGameTally.css';
import SiteNav from './components/SiteNav.js'
import Splash from './components/splash.js';

function App() {

    return (
        <>
            <div className='container is-fullheight'>
                <SiteNav />
                <Splash />
            </div>
        </>
    )
}

export default App; 
